import { useMutation, useQueryClient } from "@tanstack/react-query";
import { makeApiRequest } from "../../utils";

export const useCreateProduct = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (productData) => {
      const response = await makeApiRequest({
        endpoint: "/api/products",
        method: "POST",
        body: productData,
        json: true
      });
      if (response.error) {
        throw new Error(response.error);
      }
      return response;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["products"] });
    }
  });
};

export const useUpdateProduct = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ id, ...productData }) => {
      const response = await makeApiRequest({
        endpoint: `/api/products/${id}`,
        method: "PUT",
        body: productData,
        json: true
      });
      if (response.error) {
        throw new Error(response.error);
      }
      return response;
    },
    onSuccess: (data, variables) => {
      queryClient.invalidateQueries({ queryKey: ["products"] });
      queryClient.invalidateQueries({ queryKey: ["product", variables.id] });
    }
  });
};

export const useDeleteProduct = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (productId) => {
      const response = await makeApiRequest({
        endpoint: `/api/products/${productId}`,
        method: "DELETE"
      });
      if (response.error) {
        throw new Error(response.error);
      }
      return response;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["products"] });
    }
  });
};
